import React from 'react';
import ReactHtmlParser from "react-html-parser";
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { windowActions } from '../../../store/windowStore';

import SvgCross from '../../../img/icons/Cross';
import SvgBBiconsPin from '../../../img/icons/BBicons_Pin';

class SearchTipWindow extends React.Component {
    render() {
        return (
            <div className='window-basic search-tips'>
                <div className='window-header' >
                    <div className='header-title tips'>{this.props.title}{this.props.hideExtendedTitle === true ? null : <Translate id='SearchTips.Title' />}</div>
                    <div className='header-icons'>
                        {this.props.dragAllowed && <div onClick={() => this.props.toggleDrag(this.props.id)}>
                            {!this.props.dragEnabled && <SvgBBiconsPin className='icon-centered'style={{transform: 'rotate(-45deg)'}}/>}
                            {this.props.dragEnabled && <SvgBBiconsPin className='icon-centered'/>}
                        </div>}
                        <div onClick={() => this.props.closeWindow(this.props.id)}>
                            <SvgCross className='icon-centered'/>
                        </div>
                    </div>
                </div>
                <div className='window-content content'>
                    {ReactHtmlParser(this.props.bodyHtml)}
                </div>
            </div>
        )
    }
}

export default connect(
    undefined,
    dispatch => bindActionCreators(windowActions, dispatch)
)(SearchTipWindow);